import { type JSX, useEffect, useState } from "react";

export function ProgressiveImg({
	previewSrc,
	src,
	...props
}: JSX.IntrinsicElements["img"] & { previewSrc?: string }) {
	const [imgSrc, setImgSrc] = useState(previewSrc || src);

	useEffect(() => {
		if (!src) return;

		const img = new Image();
		img.src = src;
		img.onload = () => {
			setImgSrc(src);
		};
	}, [src]);

	const customClass =
		previewSrc && imgSrc === previewSrc ? "image-loading" : "image-loaded";

	return (
		<img
			{...{ src: imgSrc, ...props }}
			alt={props.alt ?? ""}
			className={`${props.className} ${customClass}`}
		/>
	);
}

export function usePrefetchImage(src?: string) {
	useEffect(() => {
		if (!src) return;

		const img = new Image();
		img.src = src;
		img.onload = () => {};
	}, [src]);
}
